export default "__VITE_ASSET__4dzukMMh__"